import { render, staticRenderFns } from "./a-order-discount.vue?vue&type=template&id=6cca80ad&scoped=true&"
import script from "./a-order-discount.vue?vue&type=script&lang=js&"
export * from "./a-order-discount.vue?vue&type=script&lang=js&"
import style0 from "./a-order-discount.vue?vue&type=style&index=0&id=6cca80ad&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca80ad",
  null
  
)

export default component.exports